export var virtualCardTheme = {
  baseStyle: {
    brand: {
      display: 'inline-flex',
      width: '80px',
      justifyContent: 'flex-end',
      // Override internal styles to avoid making adjustments to global components, which could potentially lead to UI changes.
      '> *': {
        maxWidth: '100%'
      },
      '[role="img"]': {
        maxWidth: '100%'
      }
    }
  }
};
//# sourceMappingURL=VirtualCard.theme.js.map